/**
 * The one loading indicator for the app — a brand-coloured ring instead of "Loading…" text.
 * `Spinner` is the bare ring (inline, e.g. inside a picker button); `Loader` centres it in a
 * block for page/list loading states and takes the full viewport when `fullScreen`.
 */
export function Spinner({ size = 'md', className = '' }: { size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const px = { sm: 'h-4 w-4 border-2', md: 'h-7 w-7 border-[3px]', lg: 'h-10 w-10 border-4' }[size];
  return <span role="status" aria-label="Loading" className={`inline-block shrink-0 animate-spin rounded-full border-brand-100 border-t-brand-500 ${px} ${className}`} />;
}

export function Loader({ fullScreen = false, className = '' }: { fullScreen?: boolean; className?: string }) {
  return (
    <div className={`grid place-items-center ${fullScreen ? 'min-h-dvh' : 'py-12'} ${className}`}>
      <Spinner size={fullScreen ? 'lg' : 'md'} />
    </div>
  );
}
